/*
 * O marcador no store (`bookmarks`), espelho do BookmarkResource do PHP.
 */
import Model from 'flarum/common/Model';
export default class Bookmark extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  reminderAt() {
    return Model.attribute('reminderAt', Model.transformDate).call(this);
  }
  remindedAt() {
    return Model.attribute('remindedAt', Model.transformDate).call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  updatedAt() {
    return Model.attribute('updatedAt', Model.transformDate).call(this);
  }
  post() {
    return Model.hasOne('post').call(this);
  }

  /** Lembrete marcado e ainda não enviado. */
  hasPendingReminder() {
    return !!this.reminderAt() && !this.remindedAt();
  }
}
flarum.reg.add('ramon-canela', 'forum/features/bookmarks/Bookmark', Bookmark);